import { REENTRY_PLANS_LIST_PATH } from '../../modules/reentry-planning/constants/reentry-planning.constants';
import { FORMS_TAB_HASH } from './forms.constants';

/**
 * Modules that compose the shared Forms tab. The source travels in the `?source=` query param
 * of Forms sub-pages (submissions, create, edit) so back navigation survives refresh and
 * direct links. Feeds is the default and keeps its URLs param-free.
 */
export const FORM_SOURCE = Object.freeze({
  FEEDS: 'feeds',
  REENTRY_PLANNING: 'reentry-planning',
});

export const DEFAULT_FORM_SOURCE = FORM_SOURCE.FEEDS;

export const FORM_SOURCE_QUERY_PARAM = 'source';

export const FEEDS_FORMS_TAB_ROUTE = `/feeds#${FORMS_TAB_HASH}`;

export const REENTRY_PLANNING_FORMS_TAB_ROUTE = `${REENTRY_PLANS_LIST_PATH}#${FORMS_TAB_HASH}`;

export const FORM_SOURCE_RETURN_ROUTES = Object.freeze({
  [FORM_SOURCE.FEEDS]: FEEDS_FORMS_TAB_ROUTE,
  [FORM_SOURCE.REENTRY_PLANNING]: REENTRY_PLANNING_FORMS_TAB_ROUTE,
});

/** Copy for the "back" button on Forms sub-pages, named after the host module. */
export const FORM_SOURCE_BACK_LABELS = Object.freeze({
  [FORM_SOURCE.FEEDS]: 'Back to Feeds',
  [FORM_SOURCE.REENTRY_PLANNING]: 'Back to Re-Entry Planning',
});
